import React from "react";
import HeaderSection from "../../../Components/HeaderSection/HeaderSection";

import "../Styles/PressReleaseWraper.css";
import Text from "../../../Components/Text/Text";
import { Helmet } from "react-helmet";
import PressReleaseWrapperEach from "../Components/PressReleaseWrapperEach/PressReleaseWrapperEach";

export default function PressReleaseWraper() {
  const PressRelease = [

    {

      // A Spectacular Night in Chinese Taipei: DynaSys Networks Bags Major Awards at APICTA 2025 
      PressReleaseImage:
        "/Images/smarter-buildings-start-here-press-wrapper.webp",
      PressReleaseImageMob:
        "/Images/smarter-buildings-start-here-press-wrapper.webp",
      PressReleaseDate: "Wed 08 Apr, 2026",
      PressReleaseHeading:
        "Smarter Buildings Start Here: DynaSys Networks and Milesight Unveil the “EG71 Building IoT Gateway”",
      PressReleaseDetails:
        "DynaSys Networks, Pakistan's premier IoT solutions provider, has partnered with Milesight a globally recognized leader in IoT technology... ",
      PressReleaseLink:
        `/our_news/smarter-buildings-start-here-dynaSys-networks-and-milesight-unveil-the-eg71-building-iot-gateway`,
    },

    {
      // A Spectacular Night in Chinese Taipei: DynaSys Networks Bags Major Awards at APICTA 2025 
      PressReleaseImage:
        "/Images/a-spectacular-night-in-chinese-aipei-press-wrapper.webp",
      PressReleaseImageMob:
        "/Images/a-spectacular-night-in-chinese-aipei-press-wrapper.webp",
      PressReleaseDate: "Mon 08 Dec, 2025",
      PressReleaseHeading:
        "A Spectacular Night in Chinese Taipei: DynaSys Networks Bags Major Awards at APICTA 2025 ",
      PressReleaseDetails:
        "DynaSys Networks, a leading Internet of Things (IoT) network operator and solutions provider received major accolades at the Asia Pacific...",
      PressReleaseLink:
        `/our_news/a-spectacular-night-in-chinese-taipei-dynaSys-networks-bags-major-awards-at-apicta-2025`,
    },
    {

      // Jazz & DynaSys Ignite Pakistan’s First Smart City Revolution with LoRaWAN Network Enablement
      PressReleaseImage:
        "/Images/jazz-dynasys-ignite-pakistan-press-wrapper.webp",
      PressReleaseImageMob:
        "/Images/jazz-dynasys-ignite-pakistan.webp",
      PressReleaseDate: "Thu 23 Oct, 2025",
      PressReleaseHeading:
        "Jazz & DynaSys Ignite Pakistan’s First Smart City Revolution with LoRaWAN Network Enablement",
      PressReleaseDetails:
        "Jazz, Pakistan’s largest digital services provider, in partnership with DynaSys Networks, a leader in Internet of Things (IoT) solutions...",
      PressReleaseLink:
        `/our_news/jazz-and-dynasys-ignite-pakistan-first-smart-city-revolution-with-lorawan-network-enablement`,
    },


    {

      // Disrupt-X, Intel, and DynaSys Networks Collaborate to Drive Digital Transformation for Critical Infrastructure ...
      PressReleaseImage:
        "/Images/disrupt-dynasys-collaborate-press-wrapper.webp",
      PressReleaseImageMob:
        "/Images/disrupt-dynasys-collaborate.webp",
      PressReleaseDate: "Tue 21 Oct, 2025",
      PressReleaseHeading:
        "Disrupt-X, Intel, and DynaSys Networks Collaborate to Drive Digital Transformation for Critical Infrastructure ...",
      PressReleaseDetails:
        "Joint initiative explores AI-enabled climate resilience, smart utilities, and sustainable infrastructure at national scale.",
      PressReleaseLink:
        `/our_news/disrupt-x-intel-and-dynasys-networks-collaborate-to-drive-digital-transformation-for-critical-infrastructure`,
    },

    {
      // DynaSys and Plan-S To Connect Earth’s Most Remote Areas via Satellite IoT
      PressReleaseImage:
        "/Images/dynasys-and-plan-s-partner-press-wrapper.webp",
      PressReleaseImageMob:
        "/Images/dynasys-and-plan-s-partner.webp",
      PressReleaseDate: "Wed 15 Oct, 2025",
      PressReleaseHeading:
        "DynaSys and Plan-S To Connect Earth’s Most Remote Areas via Satellite IoT",
      PressReleaseDetails:
        "DynaSys Networks, a leader in Internet of Things (IoT) solutions, and Plan-S, Türkiye’s pioneering space technology company...",
      PressReleaseLink:
        "/our_news/dynasys_plan_s_partner_to_bring_satellite_powered",
    },

    // Disrupt-X and DynaSys Join Hands to Develop Infrastructure in Pakistan to Support 40 Million Smart Water Meters
    {
      PressReleaseImage:
        "/Images/disrupt-x-and- dynasys-join hands-press-wrapper.webp",
      PressReleaseImageMob:
        "/Images/disrupt-x-and- dynasys-join hands-press-image-mobile.webp",
      PressReleaseDate: "Thu 09 Oct, 2025",
      PressReleaseHeading:
        "Disrupt-X and DynaSys Join Hands to Develop Infrastructure in Pakistan to Support 40 Million Smart Water Meters",
      PressReleaseDetails:
        "Disrupt-X and DynaSys Networks (“DynaSys”) have announced a landmark initiative to enhance ALEF, the unified IoT platform and communications...",
      PressReleaseLink: "/our_news/disrupt_x_and_dynasys_join_hands",
    },

    // DynaSys Networks Bags 4 Awards at HBL P@SHA ICT Awards 2025
    {
      PressReleaseImage: "/Images/dynasys-pasha-2025-press-wrapper.webp",
      PressReleaseImageMob: "/Images/dynasys-pasha-2025-mobile.webp",
      PressReleaseDate: "Fri 19 Sep, 2025",
      PressReleaseHeading:
        "DynaSys Networks Bags 4 Awards at HBL P@SHA ICT Awards 2025",
      PressReleaseDetails:
        "The spotlight at HBL P@SHA ICT Awards 2025 was on DynaSys Networks, which walked away with an impressive four (04) awards, making it the most decorated...",
      PressReleaseLink:
        "/our_news/dynasys_networks_awards_hbl_pasha_awards_2025",
    },

    // NADRA Technologies Joins Forces with DynaSys to Accelerate IoT Adoption in Pakistan
    {
      PressReleaseImage:
        "/Images/nadra-technologies-joins-forces-press-wrapper.webp",
      PressReleaseImageMob: "/Images/nadra-technologies-joins-forces.webp",
      PressReleaseDate: "Sat 13 Sep, 2025",
      PressReleaseHeading:
        "NADRA Technologies Joins Forces with DynaSys to Accelerate IoT Adoption in Pakistan",
      PressReleaseDetails:
        "NADRA Technologies Limited (NTL), Pakistan's National Database and Registration Authority's (NADRA) commercial division, and DynaSys Networks...",
      PressReleaseLink:
        "/our_news/nadra_technologies_joins_forces_with_dynasys",
    },

    //DynaSys and Jazz Launch First City-Wide LoRaWAN Network in Lahore, Pioneering Pakistan Digital Future
    // {
    //   PressReleaseImage: "/Images/WeatherWalay_DynaSys_Networks_Partner_Press_wrapper.webp",
    //   PressReleaseImageMob: "/Images/WeatherWalay_DynaSys_Networks_Partner.webp",
    //   PressReleaseDate: "Mon 01 Sep, 2025",
    //   PressReleaseHeading:
    //     "DynaSys and Jazz Launch First City-Wide LoRaWAN Network in Lahore, Pioneering Pakistan Digital Future",
    //   PressReleaseDetails:
    //     "In a landmark move for Pakistan&#39;s digital landscape, DynaSys Networks, a leader in Internet of Things (IoT) solutions, and Jazz, the country’s largest...",
    //   PressReleaseLink: "/our_news/dynaSys_jazz_launch_first_city_wide_lorawan_network",
    // },

    // WeatherWalay and DynaSys Networks Partner to Leverage IoT for Climate Monitoring and Disaster Management
    {
      PressReleaseImage: "/Images/MuhammadUzairAkhtarImagePressWrapper.webp",
      PressReleaseImageMob: "/Images/Muhammad_Uzair_Akhtar_mobile.webp",
      PressReleaseDate: "Sat 30 Aug, 2025",
      PressReleaseHeading:
        "Muhammad Uzair Akhtar Appointed as Head of Products – IoT at DynaSys Networks",
      PressReleaseDetails:
        "DynaSys Networks announced today that Muhammad Uzair Akhtar has been appointed as the Head of Products - IoT.",
      PressReleaseLink:
        "/our_news/muhammad_uzair_akhtar_appointed_head_of_products_iot_at_dynasys_networks",
    },

    //  DynaSys Networks Signs Strategic MoU with APPLIOT GLOBAL to Accelerate Global IoT Expansion
    {
      PressReleaseImage:
        "/Images/WeatherWalay_DynaSys_Networks_Partner_Press_wrapper.webp",
      PressReleaseImageMob:
        "/Images/WeatherWalay_DynaSys_Networks_Partner.webp",
      PressReleaseDate: "Fri 08 Aug, 2025",
      PressReleaseHeading:
        "WeatherWalay and DynaSys Networks Partner to Leverage IoT for Climate Monitoring and Disaster Management",
      PressReleaseDetails:
        "DynaSys Networks, a leading innovator in Internet of Things (IoT) solutions, and WeatherWalay, Pakistan’s largest private weather and environmental...",
      PressReleaseLink:
        "/our_news/weatherwalay_and_dynasys_networks_partner_to_leverage_iot_for_climate",
    },

    //  DynaSys Networks Signs Strategic MoU with APPLIOT GLOBAL to Accelerate Global IoT Expansion
    {
      PressReleaseImage:
        "/Images/DynaSys NetworksSignsStrategicMoUPressWrapper.png",
      PressReleaseImageMob:
        "/Images/DynaSys NetworksSignsStrategicMoUMobileImage.png",
      PressReleaseDate: "Thu 26 June, 2025",
      PressReleaseHeading:
        "DynaSys Networks Signs Strategic MoU with APPLIOT GLOBAL to Accelerate Global IoT Expansion",
      PressReleaseDetails:
        "The MoU outlines a shared vision to capture significant market share in the rapidly evolving IoT sector across South Asia, Southeast Asia, Africa, the...",
      PressReleaseLink: "/our_news/dynaSys_networks_signs_strategic_mou",
    },

    //  A Major IoT Partnership Emerges in Pakistan Milesight and DynaSys Networks Join Hands to Drive IoT Innovation
    {
      PressReleaseImage:
        "/Images/Pakistan_Milesight_and_DynaSys_Networks _join Hands_pressWrapper.png",
      PressReleaseImageMob:
        "/Images/Pakistan_Milesight_and_DynaSys_Networks _join Hands_Mobile.png",
      PressReleaseDate: "Thu 19 June, 2025",
      PressReleaseHeading:
        "A Major IoT Partnership Emerges in Pakistan Milesight and DynaSys Networks Join Hands to Drive IoT Innovation",
      PressReleaseDetails:
        "Milesight, a global leader in cutting-edge IoT hardware and AI-driven solutions, has formed a strategic partnership with DynaSys Networks...",
      PressReleaseLink:
        "/our_news/pakistan_milesight_and_dynaSys_networks_join_hands",
    },

    // Jazz Partners with DynaSys to Accelerate IoT-Driven Innovation in Pakistan
    {
      PressReleaseImage: "/Images/jazzPartnersPressWrapperImage.png",
      PressReleaseImageMob: "/Images/jazzPartnersPressWrapperImageMobile.png",
      PressReleaseDate: "Mon 12 May, 2025",
      PressReleaseHeading:
        "Jazz Partners with DynaSys to Accelerate IoT-Driven Innovation in Pakistan",
      PressReleaseDetails:
        "Jazz, Pakistan’s leading digital operator, has partnered with DynaSys Networks, a leading provider of Internet of Things (IoT) solutions, to accelerate..",
      PressReleaseLink:
        "/our_news/jazz_partners_with_dynaSys_to_accelerate_iot_Driven_innovation_in_pakistan",
    },

    // Azercosmos Activates First IoT Solution on Azerspace- 1 in Partnership with DynaSys Networks
    {
      PressReleaseImage: "/Images/Azercosmos Activates_press_wrapper.webp",
      PressReleaseImageMob:
        "/Images/Azercosmos Activates_press_wrapper_Mobile.webp",
      PressReleaseDate: "Wed 19 March, 2025",
      PressReleaseHeading:
        "Azercosmos Activates First IoT Solution on Azerspace- 1 in Partnership with DynaSys Networks",
      PressReleaseDetails:
        "Azerbaijan’ Space Agency - Azercosmos, today  announced that it had activated the first IoT solution over it’s  own geostationary satellite, Azerspace -1..",
      PressReleaseLink: "/our_news/azercosmos_activates_first_iot_solution",
    },

    // DynaSys Networks Recognized for its Innovation in IoT at APICTA Awards 2024
    {
      PressReleaseImage: "/Images/Aamir-Bashir-Joins.webp",
      PressReleaseImageMob:
        "/Images/Aamir-Bashir-Joins_press_wrapper_mobile.webp",

      PressReleaseDate: "Tue 10 Dec, 2024",
      PressReleaseHeading:
        "M. Aamir Bashir Joins DynaSys Networks as Head of Business Unit - Systems Integration",
      PressReleaseDetails:
        "With over 26 years of Telecoms and ICT experience in Defense, M. Aamir Bashir adds to the strategic depth of the leadership team at DynaSys Networks.",
      PressReleaseLink: "/our_news/aamir_bashir_joins_dynasys",
    },

    // DynaSys Networks Recognized for its Innovation in IoT at APICTA Awards 2024
    {
      PressReleaseImage: "/Images/Dynasys_Apicta_Image.webp",
      PressReleaseImageMob:
        "/Images/Dynasys_Apicta_Image_press_wrapper_mobile.webp",

      PressReleaseDate: "Sat 7 Dec, 2024",
      PressReleaseHeading:
        "DynaSys Networks Recognized for its Innovation in IoT at APICTA Awards 2024",
      PressReleaseDetails:
        "DynaSys Networks, a leading innovator on the Internet of Things (IoT) space, is proud to announce that it has been recognized at..",
      PressReleaseLink: "/our_news/dynasys_networks_at_apicta_awards",
    },

    // DynaSys Networks and PakSat International Pioneer IoT over Satellite Networks in Pakistan
    {
      PressReleaseImage: "/Images/DynaSys_PakSat_International_Pioneer.webp",
      PressReleaseImageMob:
        "/Images/DynaSys_PakSat_International_Pioneer_press_wrapper_mobile.webp",

      PressReleaseDate: "Fri 29 Nov, 2024",
      PressReleaseHeading:
        "DynaSys Networks and PakSat International Pioneer IoT over Satellite Networks in Pakistan",
      PressReleaseDetails:
        "PakSat International, Pakistan’s national satellite operator and DynaSys Networks, a technology company with a cutting-edge Internet of Things..",
      PressReleaseLink:
        "/our_news/dynasys_networks_and_paksat_international_pioneer",
    },

    // DynaSys Networks Pioneers Pakistan's IoT Future
    {
      PressReleaseImage: "/Images/DynasysNetworkPioneerPressWrapper.webp",
      PressReleaseImageMob:
        "/Images/DynasysNetworkPioneerPressWrapper_mobile.webp",

      PressReleaseDate: "Tue 19 Nov, 2024",
      PressReleaseHeading:
        "DynaSys Networks Pioneers Pakistan's IoT Future: The Country’s First Commercial IoT LoRaWAN Network Goes Live",
      PressReleaseDetails:
        "DynaSys Networks, is thrilled to announce the successful go-live status of the first commercial IoT LoRaWAN Network..",
      PressReleaseLink:
        "/our_news/dynasys_networks_pioneers_pakistan's_iot_future",
    },

    // DynaSys Triumphs Twice at HBL P@SHA ICT Awards 2024
    {
      PressReleaseImage: "/Images/DynaSysTriumphsTwiceImage.webp",
      PressReleaseImageMob:
        "/Images/DynaSysTriumphsTwiceImage_press_wrapper_mobile.webp",
      PressReleaseDate: "Mon 23 Sep, 2024",
      PressReleaseHeading:
        "DynaSys Triumphs Twice at HBL P@SHA ICT Awards 2024",
      PressReleaseDetails:
        "DynaSys Networks, a leading innovator in Pakistan in Internet of Things technology and service, is thrilled to announce that it won two awards at the prestigious HBL..",
      PressReleaseLink: "/our_news/dynasys_triumphs_twice_at_hbl_pasha",
    },
    // Azercosmos to Offer IoT Solutions Across Its Satcom Network..
    {
      PressReleaseImage: "/Images/azercosmosPaternship.webp",
      PressReleaseImageMob: "/Images/azercosmosPaternship_press_wrapper.webp",
      PressReleaseDate: "Tue 09 July, 2024",
      PressReleaseHeading:
        "Azercosmos to Offer IoT Solutions Across Its Satcom Network in Partnership with DynaSys Networks",
      PressReleaseDetails:
        "DynaSys Networks, a technology company with a cutting-edge Internet of Things ecosystem. .",
      PressReleaseLink: "/our_news/azercosmos_offer_iot_solution",
    },
    // DynaSys and TSGN Join Forces to Accelerate IoT Growth..
    {
      PressReleaseImage: "/Images/DynasysTsgn.webp",
      PressReleaseImageMob: "/Images/DynasysTsgn_press_wrapper_mobile.webp",
      PressReleaseDate: "Mon 03 June, 2024",
      PressReleaseHeading:
        "DynaSys and TSGN Join Forces to Accelerate IoT Growth in South East Asia",
      PressReleaseDetails:
        "DynaSys Networks, a leading provider of Internet of Things (IoT) solutions, and TS Global Network (TSGN), a prominent Malaysian origin regional satellite..",
      PressReleaseLink: "/our_news/dynasys_tsgn_join_forces",
    },
    // DynaSys and Pronet ink MoU
    {
      PressReleaseImage: "/Images/dynasysPronet.webp",
      PressReleaseImageMob: "/Images/dynasysPronet_press_wrapper_mobile.webp",
      PressReleaseDate: "Mon 20 May, 2024",
      PressReleaseHeading:
        "IoT Innovation in Pakistan Accelerated - DynaSys and Pronet ink MoU",
      PressReleaseDetails:
        "DynaSys Networks (DynaSys), a leader in the IoT space and Pronet, a renowned system integrator in Pakistan have signed a Memorandum of Understanding..",
      PressReleaseLink: "/our_news/dynasys_pronet_ink_mou",
    },
    // Inotech and DynaSys Combine Forces to Commercialize IoT in Pakistan
    {
      PressReleaseImage: "/Images/inotechDynasysresReleaseWrapper.webp",
      PressReleaseImageMob:
        "/Images/inotechDynasysresReleaseWrapper_mobile.webp",
      PressReleaseDate: "Tue 06 Feb, 2024",
      PressReleaseHeading:
        "Inotech and DynaSys Combine Forces to Commercialize IoT in Pakistan",
      PressReleaseDetails:
        "Inotech Solutions (Inotech) and DynaSys Networks (DynaSys) have signed a Memorandum of Understanding (MoU) during a ceremony held at the National Incubation Center..",
      PressReleaseLink: "/our_news/inotech_dynasys",
    },
    // DynaSys Networks and Xiplink Awarded Cellular Backhaul..
    {
      PressReleaseImage: "/Images/dynasysXiplinkPressReleaseWrapperImage.webp",
      PressReleaseImageMob:
        "/Images/dynasysXiplinkPressReleaseWrapperImage_mobile.webp",
      PressReleaseDate: "Wed 11 Oct, 2023",
      PressReleaseHeading:
        "DynaSys Networks and Xiplink Awarded Cellular Backhaul Optimization Project in Central Asia",
      PressReleaseDetails:
        "XipLink Inc., the technology leader in Wireless Link Optimization, and DynaSys Networks, an up-and-coming Systems Integrator, are pleased to announce..",
      PressReleaseLink: "/our_news/dynasys_xiplink",
    },
    //  PTCL & DynaSys Networks Join Hands
    {
      PressReleaseImage: "/Images/PtclDynasysPressReleaseWraperImg2.webp",
      PressReleaseImageMob:
        "/Images/PtclDynasysPressReleaseWraperImg2_mobile.webp",
      PressReleaseDate: "Tue 12 Sep, 2023",
      PressReleaseHeading:
        "PTCL & DynaSys Join Hands to Take IoT & Satellite Communications to the Next Level",
      PressReleaseDetails:
        "Pakistan Telecommunication Company Limited (PTCL) and DynaSys Networks (DynaSys) have signed two Memoranda of Understandings (MoUs)..",
      PressReleaseLink: "/our_news/ptcl_dynasys",
    },
    //  DynaSys Networks receives IoT LPWAN License from Pakistan Telecommunication Authority
    {
      PressReleaseImage: "/Images/mousPressReleaseWrapper.webp",
      PressReleaseImageMob: "/Images/mousPressReleaseWrapper_mobile.webp",
      PressReleaseDate: "Wed 06 Sep, 2023",
      PressReleaseHeading:
        "DynaSys Networks receives IoT LPWAN License from Pakistan Telecommunication Authority",
      PressReleaseDetails:
        "DynaSys Networks announced today that the Pakistan Telecommunication Authority has issued an IoT LPWAN license to it for a 5-year period.",
      PressReleaseLink: "/our_news/iot_license",
    },
    //  Imran Farooq Joins DynaSys Networks as Chief Technology Officer
    {
      PressReleaseImage: "/Images/ImranpressWraperImage.webp",
      PressReleaseImageMob: "/Images/ImranpressWraperImage_mobile.webp",
      PressReleaseDate: "Fri 25 Aug, 2023",
      PressReleaseHeading:
        "Imran Farooq Joins DynaSys Networks as Chief Technology Officer",
      PressReleaseDetails:
        "With over 19 years of in-depth IT, Telecoms and Satellite Communications experience, Imran Farooq provides a major boost to the technology team at DynaSys Networks.",
      PressReleaseLink: "/our_news/imran_farooq_press_release",
    },
    //  Disrupt-X and DynaSys Networks Announce Innovative Partnership
    {
      PressReleaseImage: "/Images/disruptpresssmall.webp",
      PressReleaseImageMob: "/Images/DynasysTsgn_press_wrapper_mobile.webp",
      PressReleaseDate: "Tue 08 Aug, 2023",
      PressReleaseHeading:
        "Disrupt-X and DynaSys Networks Announce Innovative Partnership to Catalyze IoT Rollout in Pakistan",
      PressReleaseDetails:
        "Disrupt-X partners with DynaSys Networks to fast-track IoT adoption, marking a significant leap in Pakistan's digital landscape.",
      PressReleaseLink: "/our_news/disrupt_x_press_release",
    },
    //  Hamid Nawaz Joins DynaSys Networks  as Chairman of the Board
    // {
    //   PressReleaseImage: "/Images/press_inner_hamid.webp",
    //   PressReleaseImageMob: "/Images/press_inner_hamid_mobile.webp",
    //   PressReleaseDate: "Tue 25 Jul, 2023",
    //   PressReleaseHeading:
    //     "Hamid Nawaz Joins DynaSys Networks  as Chairman of the Board",
    //   PressReleaseDetails:
    //     "With over 26 years of global IT, Telecoms and Satellite Communications experience, Hamid Nawaz brings unique expertise, all-round high energy, and time-tested leadership to DynaSys Networks.",
    //   PressReleaseLink: "/our_news/hamid_nawaz_press_release",
    // },
  ];
  return (
    <div className="PressReleaseWraper">
      <Helmet>
        <title>Our News</title>
      </Helmet>
      <div className="Page_Body">
        <div className="Page_Body_wraper">
          <HeaderSection
            BannerText="Our News"
            Src="/Images/PressReleasebanner.webp"
            text="Media Center <span>/</span>"
            text1="Our News"
            RouteLink1="/our_news"
            Color1="#6C6C6C"
            Color2="black"
          />
          <div className="leadershipdetails">
            <Text text="Our News" FontSize="3rem" FontWeight="700" />
          </div>
          <div className="press_release_container">
            {PressRelease.map((item) => (
              <PressReleaseWrapperEach
                Src={item.PressReleaseImage}
                SrcMob={item.PressReleaseImageMob}
                PressDate={item.PressReleaseDate}
                PressHead={item.PressReleaseHeading}
                PressDetails={item.PressReleaseDetails}
                PressLink={item.PressReleaseLink}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="borderSec">
        <div className="border"></div>
      </div>
    </div>
  );
}
